export default axios => ({
  async getMemberships() {
    const url = '/memberships/'
    return (await axios.get(url)).data.data
  },

  async getPayin(reqOptions) {
    // console.log(reqOptions)
    const url = `/payin/data/${reqOptions.currency}`
    const params = reqOptions.currency
    return (await axios.get(url, { params })).data.data
  },

  async setPayin({ amount, type }) {
    const url = '/payin/invoice/'
    const data = {
      amount,
      currency: 'RUB',
      balance_type: type
    }
    return (await axios.post(url, data)).data.data
  },

  async getPayout({ amount, account }) {
    const url = '/payout/'
    const data = {
      amount,
      account
    }
    return (await axios.post(url, data)).data.data
  },

  async dbGetPayinData() {
    const url = '/payin/static-data/'
    return (await axios.get(url)).data.data
  },

  async dbExchangeTickets({ green, blue }) {
    const url = '/payin/exchange/'
    const data = {
      green_tickets: green,
      blue_tickets: blue
    }
    return (await axios.post(url, data)).data.data
  }
})



// WEBPACK FOOTER //
// ./src/pkg/api/finances.js